// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"_93444fe79c--dropdown--AMmWe"};